export const Constants = {
    elementTypes: {
        TextField: 'text',
        TextArea: 'textarea',
        Email: 'email',
        Phone: 'phone',
        Radio: 'radio',
        CheckBox: 'checkbox',
        Select: 'select',
        Picture: 'picture',
        File: 'file',
        Question: 'question',
        Contact: "contact",
        Address: "address",
        Date: "date",
        Time: "time"
    },
    themes: [
        {
            background: "#FFFFFF",
            text: "#2f3359"
        },
        {
            background: "#DFDFDF",
            text: "#2f3359"
        },
        {
            background: "#BEBEBE",
            text: "#2f3359"
        },
        {
            background: "#9C9C9C",
            text: "#2f3359"
        },
        {
            background: "#787878",
            text: "#FFFFFF"
        },
        {
            background: "#525252",
            text: "#FFFFFF"
        },
        {
            background: "#282828",
            text: "#FFFFFF"
        },
        {
            background: "#F4F8FB",
            text: "#2f3359"
        },
        {
            background: "#E9F1F7",
            text: "#2f3359"
        },
        {
            background: "#D4E4F0",
            text: "#2f3359"
        },
        {
            background: "#A9C9E2",
            text: "#2f3359"
        },
        {
            background: "#7FADD3",
            text: "#2f3359"
        },
        {
            background: "#5492C5",
            text: "#FFFFFF"
        },
        {
            background: "#2977B6",
            text: "#FFFFFF"
        },
        {
            background: "#FEFAF6",
            text: "#2f3359"
        },
        {
            background: "#FEF6ED",
            text: "#2f3359"
        },
        {
            background: "#FEEDDC",
            text: "#2f3359"
        },
        {
            background: "#FCDBB9",
            text: "#2f3359"
        },
        {
            background: "#FBCA95",
            text: "#2f3359"
        },
        {
            background: "#F9B872",
            text: "#FFFFFF"
        },
        {
            background: "#F8A64F",
            text: "#FFFFFF"
        }
    ],
    status: {
        resubmit: "Please check the error and resubmit the form"
    },
    viewElements:["text", "textarea", "email", "phone", "radio", "select", "picture", "file", "question", "contact", "address", "date", "time"],
    elements: [
        // {
        //     key: "text",
        //     name: "Single line text",
        //     img: "../../assets/images/single-line.svg"
        // },
        {
            key: "phone",
            name: "Phone",
            img: "../../assets/images/phone-field-icon.svg"
        },
        {
            key: "email",
            name: "Email",
            img: "../../assets/images/email-field-icon.svg"
        },
        {
            key: "textarea",
            name: "Text Box",
            img: "../../assets/images/multi-line-icon.svg"
        },
        {
            key: "radio",
            name: "Options Buttons",
            img: "../../assets/images/options-icon.svg"
        },
        {
            key: "select",
            name: "Dropdown Box",
            img: "../../assets/images/dropdown-box.svg"
        },
        {
            key: "picture",
            name: "Picture Upload",
            img: "../../assets/images/picture-upl-icon.svg"
        },
        {
            key: "file",
            name: "File Upload",
            img: "../../assets/images/file-upload.svg"
        },
        {
            key: "question",
            name: "Yes/No Buttons",
            img: "../../assets/images/yes-no-icon.svg"
        },
        {
            key: "contact",
            name: "Request to be Contacted",
            img: "../../assets/images/contact.svg"
        },
        // {
        //     key: "checkbox",
        //     name: "Checkbox",
        //     img: "../../assets/images/contact.svg"
        // }
        {
            key: "address",
            name: "Address",
            img: "../../assets/images/address-icon.svg"
        },
        {
            key: "date",
            name: "Date",
            img: "../../assets/images/calender-one-icon.svg"
        },
        {
            key: "time",
            name: "Time",
            img: "../../assets/images/time-one-icon.svg"
        },
    ],
    versionNumber: "V1.0.14416040",
    emailPattern: /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/,
    maxOrgs: 2,
    acceptedFileTypes: ['application/pdf'],
    acceptedImageTypes: ['image/jpeg', 'image/jpg','image/gif', 'image/svg+xml', 'image/tiff', 'image/x-icon', 'image/png', 'image/webp'],
    sharablePlatforms: [
        {
            platform: 'facebook',
            image: '../../assets/images/bxl-facebook.svg',
            url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fapp.sortsoftware.com&description=Simplify%20your%20business%20with%20SortForms!%20Consolidate%20communications,%20automate%20tasks,%20and%20stay%20organized%20effortlessly.%20Learn%20more:',
            label: 'Facebook'
        },
        {
            platform: 'twitter',
            image: '../../assets/images/bxl-twitter.svg',
            url: 'https://twitter.com/intent/tweet?text=Simplify%20your%20business%20with%20SortForms!%20Consolidate%20communications,%20automate%20tasks,%20and%20stay%20organized%20effortlessly.%20Learn%20more:&url=https%3A%2F%2Fapp.sortsoftware.com',
            label: 'X (Twitter)'
        },
        {
            platform: 'instagram',
            image: '../../assets/images/bxl-instagram.svg',
            url: 'https://twitter.com/intent/tweet?text=Simplify%20your%20business%20with%20SortForms!%20Consolidate%20communications,%20automate%20tasks,%20and%20stay%20organized%20effortlessly.%20Learn%20more:&url=https%3A%2F%2Fapp.sortsoftware.com',
            label: 'Instagram'
        },
        {
            platform: "copy",
            image: '../../assets/images/bxl-copy.svg',
            label: 'Copy',
            content: 'Simplify your business with SortForms! Consolidate communications, automate tasks, and stay organized effortlessly. Learn more: https://app.sortsoftware.com '
        }
    ]
};